export const LOGIN = '/login'
export const AUTOLOGIN = '/autologin'
